import { initH5 } from '@/service'
import { HeaderTagCorrespondenceList } from '@/utils/properties'
import { updateHeadTags } from '@/utils'
import { setLocalAppConfig } from '@/utils/storage'
import browser from '@/utils/browser'

const sys_platform = browser.isMobile ? (
    browser.isiOS
        ? 'ios'
        : browser.isiPad
        ? 'iPad'
        : browser.isAndroid
            ? 'android'
            : 'others'
) : 'PC'
console.log('sys_platform', sys_platform)

export default {
    namespaced: 'app',
    state: {
        appConfig: {
            muid: '',
            game: '', // 游戏加载URL
            game_id: '',
            platform: 2, // 游戏平台 0：官网 1：安卓 2： iOS
            bg: '', // 背景图URL
            username: '',
            bak: '',
            sys_platform,
        },
        gameConfig: {
            bookmark_auto_login: 0,
            'apple-touch-icon': '', /* 桌面或标题栏图标 */
            'apple-touch-startup-image': '', /* 启动闪图 */
        },
        paymentConfig: {},
        inner_wx_appid: '',//微信网页授权用到的APPID
        originQuery: {},
        notice_switch: 0,//公告开关，1为开启，0关闭
        gift_switch: 0,//礼包码开关，1为开启，0关闭
        accountFirst: '', // 首次自动生成账号名
        passwordFirst: '', // 首次自动生成密码
        gift_logo: '', // 右下角好评有礼图标
        praise_logo: '', // 好评有礼弹窗图
        add_group_logo: '', // 加群弹窗图
        coupon_logo: '', // 优惠券弹窗
        drainage_config: {}, // 引流配置
        showServiceQQ: false, // 显示客服弹窗
        showSocialMediaModal: false, // 显示社交媒体弹窗
        social_media: [], // 社交媒体链接列表
    },
    actions: {
        initH5({ commit }, data) {
            commit('UPDATE_H5_INIT_DATA', data)
        },
        updateAppConfig({ commit }, config) {
            commit('UPDATE_APP_CONFIG', config)
        },
        saveOriginQuery({ commit }, query) {
            commit('SAVE_ORIGIN_QUERY', query)
        },
        updateShowServiceQQ({ commit }, data) {
            commit('UPDATE_SHOW_SERVICE_QQ', data)
        },
        updateShowSocialMediaModal({ commit }, data) {
            commit('UPDATE_SHOW_SOCIAL_MEDIA_MODAL', data)
        }
    },
    mutations: {
        // 首次自动生成账号名
        UPDATE_ACCOUNT_FIRST(state, data) {
            state.accountFirst = data
        },
        // 首次自动生成密码
        UPDATE_PASSWORD_FIRST(state, data) {
            state.passwordFirst = data
        },
        UPDATE_APP_CONFIG(state, data) {
            state.appConfig = Object.assign({}, state.appConfig, data)
            setLocalAppConfig(state.appConfig)
        },
        UPDATE_SHOW_SERVICE_QQ(state, data) {
            state.showServiceQQ = data
        },
        UPDATE_SHOW_SOCIAL_MEDIA_MODAL(state, data) {
            state.showSocialMediaModal = data
        },
        /**
         * @param state any
         * @param data {{ bookmark_auto_login: 1 | 0,pay_config: { wx?: number, ali?: number},[title]: string }}
         *  */
        UPDATE_H5_INIT_DATA(state, data) {
            state.gameConfig.bookmark_auto_login = Number(
                data.bookmark_auto_login)
            if (data.pay_config) {
                state.paymentConfig = data.pay_config
                console.log('set payment config', JSON.stringify(state.paymentConfig))
            }
            state.inner_wx_appid = data.inner_wx_appid || ''
            state.notice_switch = data.notice_switch || 0
            state.gift_switch = data.gift_switch || 0
            console.log('set inner_wx_appid', state.inner_wx_appid)

            // 2022.04.01 增加好评有礼图片
            state.gift_logo = data.gift_logo || ''
            state.praise_logo = data.praise_logo || ''
            state.add_group_logo = data.add_group_logo || ''

            // 2022.05.27 增加跳转苹果 AppStore的 appid
            state.channel_app_id = data.channel_app_id || ''

            // 2022.07.05 增加跳转苹果应用商店的引流配置
            state.drainage_config = data.drainage_config || {}

            // 2024.12.12 优惠券弹窗图片
            state.coupon_logo = data.coupon_logo || ''

            // 社交媒体链接
            state.social_media = data.social_media || []

            data.title && (document.title = data.title)
            Object.entries(data).map(([key, value]) => {
                if (HeaderTagCorrespondenceList[key]) {
                    updateHeadTags(HeaderTagCorrespondenceList[key].tagName, [
                        {
                            key: HeaderTagCorrespondenceList[key].key,
                            value: key,
                        },
                        {
                            key: HeaderTagCorrespondenceList[key].value,
                            value: value,
                        },
                    ])
                }
            })
            return data
        },
        SAVE_ORIGIN_QUERY(state, query) {
            state.originQuery = query
        },
    },
}
